@if (label) {
<label class="_label p2">{{label}}</label>
}

<div class="_content"
     [offClickState]="expandState"
     (offClick)="closeDropdown()">
    <ng-content></ng-content>

    <!-- loader -->
    @if (isLoaderVisible) {
    <loader class="_loader"></loader>
    }

    <!-- side icon (optional) -->
    @if (sideIcon) {
    <i [ngClass]="sideIcon"
       class="_sideIcon"
       [class.pe-none]="!hasSideAction"
       (click)="sideAction()"></i>
    }

    <!-- side text (optional) -->
    @if (sideText) {
    <span class="_sideText s2"
          (click)="sideAction()">{{ sideText | translate }}</span>
    }

    <div class="pos-absolute z-4 right-0"
         *ngIf="['date'].includes(type) && !isDisabled">
        <div [hideUp]="expandState">
            <dropdown-calendar [triangle]="true"
                               [model]="inDropdownValue"
                               (modelChange)="handleInDropdownValueChange($event)"
                               [options]="calendarOptions"></dropdown-calendar>
        </div>
    </div>
</div>



@if (isValidationVisible) {
<p class="p2 m-t-1 col-2">{{ validationMsg | translate}}</p>
}

@if (helper && !isValidationVisible) {
<p class="p2 m-t-1">{{ helper | translate }}</p>
}